import * as Clipboard from 'expo-clipboard';
import { Share } from 'react-native';

type SharePayload = {
  title?: string;
  message: string;
};

export const openShareSheet = async (payload: SharePayload): Promise<void> => {
  try {
    await Share.share(payload);
  } catch {
    // Ignore share sheet cancellation/closure to avoid false-positive errors.
  }
};

export const copyToClipboard = async (value: string): Promise<void> => {
  await Clipboard.setStringAsync(value);
};
